// deps - ProductPage

var PwnageFormUtility = {
  URLManager: {
    params: null,
    init: function () {
      let p = location.search.substring(1)
      if (p) {
        try {
          var p2 = JSON.parse(
            '{"' +
              decodeURI(p)
                .replace(/"/g, '\\"')
                .replace(/&/g, '","')
                .replace(/=/g, '":"') +
              '"}'
          )
        } catch (error) {}
      }
      this.params = p2
    },

    /**
     * @param {newURL} arg - A url to be placed in the address bar.
     */
    updateURL: function (arg = {}) {
      let params = ProductPage.data.form.getParams()
      // if(arg == {}) return
      if (arg.newURL) {
        window.history.replaceState("", "", arg.newURL)
        return
      }
      if (params && params.length > 0) {
        window.history.replaceState(
          "",
          "",
          window.location.pathname + "?" + params.join("&")
        )
        return
      }
      window.history.replaceState("", "", window.location.pathname) // TODO check if this breaks
    },
  },

  PriceManager: {
    data: {},
    init: function () {
      this.data.priceEl = document.querySelectorAll(
        "[data-product-price--dynamic]"
      )
      if (this.data.priceEl.length > 0) {
        this.multiplePrices = true
        this.data.compareAtPriceEl = document.querySelectorAll(
          "[data-product-price-compare--dynamic]"
        )
        this.data.compareAtPercentageEl = document.querySelectorAll(
          "[data-product-price-compare--percentage]"
        )
        this.data.compareAtPercentageWrapper = document.querySelectorAll(
          "[data-product-price-compare--percentage-wrapper]"
        )
      } else {
        this.multiplePrices = false
        this.data.priceEl = document.getElementById("product-price--dynamic")
        this.data.compareAtPriceEl = document.getElementById(
          "product-price-compare--dynamic"
        )
        this.data.compareAtPercentageEl = document.getElementById(
          "product-price-compare--percentage"
        )
        this.data.compareAtPercentageWrapper = document.getElementById(
          "product-price-compare--percentage-wrapper"
        )
      }
      this.calculate()
    },
    calculate: function () {
      if (this.multiplePrices) {
        this.calculateMultiple()
        return
      }
      let products = ProductPage.data.form.getUniqueProducts()
      let totalPrice = products.reduce(
        (accumulatedPrice, currentProduct) =>
          accumulatedPrice + parseFloat(currentProduct.price),
        0
      )
      let totalCompareAtPrice = products.reduce(
        (accumulatedPrice, currentProduct) =>
          accumulatedPrice +
          parseFloat(
            currentProduct.compareAtPrice
              ? currentProduct.compareAtPrice
              : currentProduct.price
          ),
        0
      )

      if (this.data.priceEl) {
        const price = Shopify.formatMoney(
          totalPrice,
          ""
        )
        this.data.priceEl.innerHTML = this.data.priceEl.dataset.keepZeroes
          ? price
          : price.replace(".00", "")
      }
      if (this.data.compareAtPriceEl) {
        const compareAtPrice = Shopify.formatMoney(
          totalCompareAtPrice,
          ""
        )
        this.data.compareAtPriceEl.innerHTML =
          totalPrice == totalCompareAtPrice
            ? ""
            : this.data.compareAtPriceEl.dataset.keepZeroes
            ? compareAtPrice
            : compareAtPrice.replace(".00", "")
      }
      if (this.data.compareAtPercentageEl) {
        const compareAtPercent = Math.round(
          (totalCompareAtPrice - totalPrice) * (100 / totalCompareAtPrice)
        )
        this.data.compareAtPercentageEl.innerHTML = compareAtPercent + "%"
        if (this.data.compareAtPercentageWrapper) {
          if (compareAtPercent) {
            this.data.compareAtPercentageWrapper.classList.remove("hide")
          } else {
            this.data.compareAtPercentageWrapper.classList.add("hide")
          }
        }
      }
    },
    calculateMultiple: function () {
      let products = ProductPage.data.form.getUniqueProducts()
      let baseProduct = products[0]
      let totalPrice = products.reduce(
        (accumulatedPrice, currentProduct) =>
          accumulatedPrice + parseFloat(currentProduct.price),
        0
      )
      let totalCompareAtPrice = products.reduce(
        (accumulatedPrice, currentProduct) =>
          accumulatedPrice +
          parseFloat(
            currentProduct.compareAtPrice
              ? currentProduct.compareAtPrice
              : currentProduct.price
          ),
        0
      )

      const price = Shopify.formatMoney(
        totalPrice,
        ""
      )
      const compareAtPrice = Shopify.formatMoney(
        totalCompareAtPrice,
        ""
      )
      const compareAtPercent = Math.round(
        (totalCompareAtPrice - totalPrice) * (100 / totalCompareAtPrice)
      )
      const basePrice = Shopify.formatMoney(
        baseProduct.price,
        ""
      )
      const baseCompareAtPrice = Shopify.formatMoney(
        baseProduct.compareAtPrice,
        ""
      )
      const baseCompareAtPercent = Math.round(
        (baseProduct.compareAtPrice - baseProduct.price) *
          (100 / baseProduct.compareAtPrice)
      )
      this.data.priceEl.forEach((priceEl) => {
        if (priceEl.dataset.onlyBase) {
          priceEl.innerHTML = priceEl.dataset.keepZeroes
            ? basePrice
            : basePrice.replace(".00", "")
        } else {
          priceEl.innerHTML = price.replace(".00", "")
        }
      })
      this.data.compareAtPriceEl.forEach((compareAtPriceEl) => {
        if (compareAtPriceEl.dataset.onlyBase) {
          compareAtPriceEl.innerHTML =
            !baseProduct.compareAtPrice || basePrice == baseCompareAtPrice
              ? ""
              : baseCompareAtPrice
        } else {
          compareAtPriceEl.innerHTML =
            totalPrice == totalCompareAtPrice
              ? ""
              : compareAtPrice.replace(".00", "")
        }
      })
      this.data.compareAtPercentageEl.forEach((compareAtPercentageEl) => {
        if (compareAtPercentageEl.dataset.onlyBase && baseProduct) {
          compareAtPercentageEl.innerHTML = baseCompareAtPercent + "%"
        } else {
          compareAtPercentageEl.innerHTML = compareAtPercent + "%"
        }
      })
      this.data.compareAtPercentageWrapper.forEach(
        (compareAtPercentageWrapper) => {
          if (compareAtPercentageWrapper.dataset.onlyBase) {
            if (baseProduct.compareAtPrice) {
              compareAtPercentageWrapper.classList.remove("hide")
            } else {
              compareAtPercentageWrapper.classList.add("hide")
            }
          } else {
            if (compareAtPercent) {
              compareAtPercentageWrapper.classList.remove("hide")
            } else {
              compareAtPercentageWrapper.classList.add("hide")
            }
          }
        }
      )
    },
  },

  SliderManager: {
    data: {},
    init: function () {
      this.data.swiperEl =
        document.getElementById("product-slider") ??
        document.getElementById("modal_slider")
      if (this.data.swiperEl == null) return

      this.data.disableReset =
        this.data.swiperEl.dataset.disableReset == "true" ? true : false
      this.data.disableInitial =
        this.data.swiperEl.dataset.disableInitial == "true" ? true : false
      this.data.sliderType = this.data.swiperEl.dataset.sliderType
      this.data.selectedVariantId = this.data.swiperEl.dataset.selectedVariantId

      this.data.swiperSlidesEls =
        this.data.swiperEl.querySelectorAll(".swiper-slide")

      // swiper thumbs
      this.data.swiperThumbsEl = document.querySelector("[data-slider-thumbs]")
      if (this.data.swiperThumbsEl) {
        this.data.swiperThumbsEls =
          this.data.swiperThumbsEl.querySelectorAll(".swiper-slide")
        this.data.swiperThumbsEls.forEach((thumb) => {
          thumb.classList.remove("hide")
        })
        this.data.swiperThumbsWrapperEl =
          this.data.swiperThumbsEl.querySelector(".swiper-wrapper")
        if (this.data.swiperEl.dataset.sliderType == "multiple") {
          this.data.swiperThumbsWrapperEl.innerHTML = ""
        }

        this.data.swiperThumbs = new Swiper(this.data.swiperThumbsEl, {
          spaceBetween: 0,
          slidesPerView: "auto",
          watchSlidesVisibility: true,
          watchSlidesProgress: true,
          // watchOverflow: true,
          observe: true,
          observeParents: true,
          observeSlideChildren: true,
          freeMode: true,
          resizeObserver: true,
          centerInsufficientSlides: true,
        })
      }

      // custom thumbs
      this.data.sliderThumbnailsRootEl = document.querySelector(
        ".slider__thumbnails"
      )
      this.data.sliderThumbnailsEls = []
      if (this.data.sliderThumbnailsRootEl) {
        this.data.sliderThumbnailsEls =
          this.data.sliderThumbnailsRootEl.querySelectorAll(
            ".slider__thumbnail"
          )
      }

      const swiperContainerEl = this.data.swiperEl.querySelector(".swiper")
      const disableTouchMove =
        this.data.swiperEl.dataset.disableTouchOnFirstSlide == "true"
      if (this.data.swiperEl.dataset.type == "r3f") {
        this.data.swiperSlider = new Swiper(swiperContainerEl, {
          slidesPerView: "auto",
          observeParents: true,
          observer: true,
          spaceBetween: 25,
          lazy: true,
          scrollbar: {
            el: ".swiper-scrollbar",
            draggable: true,
            hide: false,
          },
          mousewheel: true,
          freeMode: true,
          thumbs: {
            swiper: this.data.swiperThumbs || null,
          },
          allowTouchMove: !disableTouchMove,
        })
      } else {
        this.data.swiperSlider = new Swiper(swiperContainerEl, {
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
          observeParents: true,
          observeSlideChildren: true,
          resizeObserver: true,
          on: {
            slideChange: function () {
              PwnageFormUtility.SliderManager.setSelectedSliderIndex()
            },
          },
          thumbs: {
            swiper: this.data.swiperThumbs || null,
          },
          allowTouchMove: !disableTouchMove,
        })

        if (disableTouchMove) {
          this.data.swiperSlider.on("slideChange", function (e) {
            if (this.realIndex === 0) {
              this.allowTouchMove = false
            } else {
              this.allowTouchMove = true
            }
          })
        }
      }

      this.bindUIActions()

      if (!this.data.disableInitial) {
        this.setSelectedSliderIndex(0)
        if (this.data.selectedVariantId)
          this.setSelectedSlideById(this.data.selectedVariantId)
      }
    },
    bindUIActions: function () {
      if (this.data.sliderThumbnailsRootEl == null) return
      this.data.sliderThumbnailsEls.forEach((thumbnail) => {
        thumbnail.addEventListener("click", (event) => {
          if (this.data.swiperSlider)
            this.data.swiperSlider.slideTo(thumbnail.dataset.sliderIndex)
          this.setSelectedSliderIndex()
        })
      })
    },
    reset: function () {
      if (this.data.disableReset) return
      this.setSelectedSliderIndex(0)
      // this.setSelectedSwiperThumbs(0)
    },
    // setSelectedSwiperThumbs: function (index) {
    // 	if (this.data.swiperThumbs == null) return
    // 	this.data.swiperThumbs.update()
    // 	// this.data.swiperThumbs.slideTo(index)
    // },
    setSelectedSliderIndex: function (sliderIndex) {
      if (this.data.sliderThumbnailsRootEl) {
        this.data.sliderThumbnailsEls.forEach((thumbnail) => {
          if (
            thumbnail.dataset.sliderIndex ==
            (sliderIndex != undefined
              ? sliderIndex
              : this.data.swiperSlider.realIndex)
          )
            thumbnail.classList.add("slider__thumbnail--selected")
          else thumbnail.classList.remove("slider__thumbnail--selected")
        })
      }
      if (sliderIndex != undefined && this.data.swiperSlider) {
        this.data.swiperSlider.slideTo(sliderIndex)
      }
    },
    setSelectedSlideById: function (selectedVariantId) {
      let sliderIndex = 0
      if (this.data.swiperSlidesEls) {
        this.data.swiperSlidesEls.forEach((slide, index) => {
          if (slide.dataset.variantId == selectedVariantId) {
            sliderIndex = index
          }
        })
        if (this.data.swiperSlider) this.data.swiperSlider.slideTo(sliderIndex)
      }
    },
    setSelectedVariant: function (selectedVariantIndex) {
      if (this.data.swiperThumbsEls) {
        this.data.swiperThumbsEls.forEach((thumbnail) => {
          if (thumbnail.dataset.sliderVariant == selectedVariantIndex)
            thumbnail.classList.remove("hide")
          else if (thumbnail.dataset.sliderVariant)
            thumbnail.classList.add("hide")
        })
      }
      if (this.data.swiperSlidesEls) {
        this.data.swiperSlidesEls.forEach((sliderImage) => {
          if (sliderImage.dataset.sliderVariant == selectedVariantIndex)
            sliderImage.classList.remove("hide")
          else if (sliderImage.dataset.sliderVariant)
            sliderImage.classList.add("hide")
        })
      }
      if (this.data.sliderThumbnailsEls) {
        this.data.sliderThumbnailsEls.forEach((thumbnail) => {
          if (thumbnail.dataset.sliderVariant == selectedVariantIndex)
            thumbnail.classList.remove("hide")
          else if (thumbnail.dataset.sliderVariant)
            thumbnail.classList.add("hide")
        })
      }
      this.reset()
    },
    setSelectedVariantById: function (selectedVariantId) {
      if (this.data.swiperThumbs) {
        this.data.swiperThumbsWrapperEl.innerHTML = ""
        this.data.swiperThumbsEls.forEach((storedThumbEl) => {
          if (storedThumbEl.dataset.variantId == selectedVariantId)
            this.data.swiperThumbsWrapperEl.append(storedThumbEl)
        })

        this.data.swiperThumbs.update(0)
      }

      this.data.swiperSlidesEls.forEach((sliderImage) => {
        if (sliderImage.dataset.variantId == selectedVariantId)
          sliderImage.classList.remove("hide")
        else if (sliderImage.dataset.variantId)
          sliderImage.classList.add("hide")
      })
      this.data.sliderThumbnailsEls.forEach((thumbnail) => {
        if (thumbnail.dataset.variantId == selectedVariantId)
          thumbnail.classList.remove("hide")
        else if (thumbnail.dataset.variantId) thumbnail.classList.add("hide")
      })

      this.data.swiperSlider.update()
      this.reset()
      // this.setSelectedSliderIndex()
    },
  },
}
